import React, { Component } from "react";

export default class Video extends Component {
	getEmbedFromUrl = url => {
		// Adapted from here for now: https://stackoverflow.com/questions/21607808/convert-a-youtube-video-url-to-embed-code?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
		// eslint-disable-next-line
		var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = url.match(regExp);
		
		if (match && match[2].length === 11) {
			return `//www.youtube.com/embed/${match[2]}?rel=0`;
		} else {
			return null;
		}
	};
	render() {
		const { video } = this.props;
		return (
			<div className="video-full">
				<div className="video-container -ratio-16x9">
					<iframe src={this.getEmbedFromUrl(video.file)} title={video.title} frameBorder="0" allowFullScreen />
				</div>
				{!this.props.hideCaption
					? (<div className="caption">
						<h3>{this.props.video.title}</h3>
            {/* <p>{this.props.video.title}</p> */}
					</div>)
					: null
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Video/Video.js